var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('figure',{class:_vm.classes},[(_vm.imageUrl && !_vm.errorLoading)?_c('img',{class:[
      `${_vm.baseClass}__image`,
      {
        [`${_vm.baseClass}__image--${_vm.objectFit}`]: _vm.objectFit,
      },
    ],attrs:{"src":_vm.imageUrl,"alt":_vm.alternativeText,"loading":_vm.lazyLoading ? 'lazy' : 'eager'},on:{"error":_vm.handleLoadingError}}):_c('span',{staticClass:"eicon"},[_vm._v(_vm._s(_vm.fallbackIcon))])])
}
var staticRenderFns = []

export { render, staticRenderFns }